import { render, staticRenderFns } from "./ModuleCertificate.vue?vue&type=template&id=3d1363ee"
import script from "./ModuleCertificate.vue?vue&type=script&lang=js"
export * from "./ModuleCertificate.vue?vue&type=script&lang=js"
import style0 from "./ModuleCertificate.vue?vue&type=style&index=0&id=3d1363ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports